import { ApiRetailerPaymentType } from '@vend/types'
import { useCallback } from 'react'
import { vn } from 'vend-number'
import { useAppSelector } from '../../../../state/hooks'
import { selectOutstandingBalance } from '../../../../state/slices/currentSale/currentSaleSlice'
import { SalePayment } from '../PaymentModal/types'

export const useHandleStoreCreditPayment = (
  amountTendered: string,
  onPaymentSuccess: (result: SalePayment) => void
) => {
  const oustandingBalance = useAppSelector(selectOutstandingBalance)
  const handleStoreCreditPayment = useCallback(
    (paymentType: ApiRetailerPaymentType) => {
      const hasNegativeBalance = vn(oustandingBalance).isNeg()
      if (!hasNegativeBalance) {
        // TODO: Implement store credit payment handling
      } else if (hasNegativeBalance && !vn(amountTendered).isNeg()) {
        // TODO:
      } else {
        // TODO: Implement store credit payment handling
      }
    },
    [amountTendered, oustandingBalance]
  )
  return {
    handleStoreCreditPayment,
  }
}
